module.exports = __webpack_public_path__ + "static/img/Sugih Gumilar-full.e27b5b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Sugih Gumilar-full.png
// module id = xsVg
// module chunks = 1